import { Controller } from "@hotwired/stimulus"
import { isMac } from "../../../helpers/platformHelpers"

export default class extends Controller {
  static targets = [
    "windowsOnly",
    "macOnly"
  ]

  connect() {
    if (isMac()) {
      this.showMacOnly()
    } else {
      this.showWindowsOnly()
    }
  }

  showMacOnly() {
    if (this.hasMacOnlyTarget) {
      this.macOnlyTarget.classList.toggle("hidden", false)
    }

    if (this.hasWindowsOnlyTarget) {
      this.windowsOnlyTarget.classList.toggle("hidden", true)
    }
  }

  showWindowsOnly() {
    if (this.hasMacOnlyTarget) {
      this.macOnlyTarget.classList.toggle("hidden", true)
    }

    if (this.hasWindowsOnlyTarget) {
      this.windowsOnlyTarget.classList.toggle("hidden", false)
    }
  }
}
